import { Menu, Search } from 'lucide-react'
import { Input } from '@/components/ui/Input'
import NotificationBell from '@/components/admin/NotificationBell'

interface HeaderProps {
  onMenuClick: () => void
}

export default function Header({ onMenuClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b border-beige-200">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Left section */}
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden text-brown-600 hover:text-brown-900 transition-colors"
          >
            <Menu className="w-6 h-6" />
          </button>

          {/* Search */}
          <div className="hidden sm:block w-64">
            <Input
              type="search"
              placeholder="Rechercher..."
              leftIcon={<Search className="w-4 h-4" />}
              className="py-1.5 text-sm"
            />
          </div>
        </div>

        {/* Right section */}
        <div className="flex items-center gap-4">
          {/* Notifications - STORY-033 */}
          <NotificationBell />
        </div>
      </div>
    </header>
  )
}
